import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import FlowbiteToast from "../../../../node_modules/flowbite-svelte/dist/toast/Toast.svelte";
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span aria-hidden="true"></span>`);
var root_1 = $.from_html(`<div class="slex-callout-title"><!><span> </span></div>`);
var root_2 = $.from_html(`<!> <div class="slex-callout-body"> </div>`, 1);

export default function Callout($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function tone() {
		const raw = text($.get(p).tone ?? $.get(p).type, "info").toLowerCase();

		if (raw === "error" || raw === "destructive") return "danger";
		if (raw === "neutral" || raw === "default" || raw === "muted") return "info";

		return raw;
	}

	function titleText() {
		return text($.get(p).title ?? $.get(p).label ?? $.get(p).heading);
	}

	function descriptionText() {
		return text($.get(p).text ?? $.get(p).content ?? $.get(p).description ?? $.get(p).message);
	}

	function role() {
		return tone() === "danger" ? "alert" : "note";
	}

	function color() {
		const kind = tone();

		if (kind === "success") return "green";
		if (kind === "warning") return "yellow";
		if (kind === "danger") return "red";
		if (kind === "muted" || kind === "neutral") return "gray";

		return "blue";
	}

	{
		const icon = ($$anchor) => {
			var span = root();

			$.append($$anchor, span);
		};

		let $0 = $.derived(tone);
		let $1 = $.derived(color);
		let $2 = $.derived(role);
		let $3 = $.derived(() => role() === "alert" ? "assertive" : "polite");

		FlowbiteToast($$anchor, {
			class: 'slex-callout',
			'data-scope': 'callout',
			get 'data-tone'() {
				return $.get($0);
			},

			get color() {
				return $.get($1);
			},

			get role() {
				return $.get($2);
			},

			get 'aria-live'() {
				return $.get($3);
			},
			dismissable: false,
			align: false,
			classes: { icon: "slex-callout-mark", content: "slex-callout-content" },
			icon,
			children: ($$anchor, $$slotProps) => {
				var fragment_1 = root_2();
				var node = $.first_child(fragment_1);

				{
					var consequent_1 = ($$anchor) => {
						var div = root_1();
						var node_1 = $.child(div);

						{
							var consequent = ($$anchor) => {
								InlineIcon($$anchor, {
									get name() {
										return $.get(p).icon;
									},
									className: 'slex-callout-icon'
								});
							};

							$.if(node_1, ($$render) => {
								if ($.get(p).icon) $$render(consequent);
							});
						}

						var span_1 = $.sibling(node_1);
						var text_1 = $.child(span_1, true);

						$.reset(span_1);
						$.reset(div);
						$.template_effect(($0) => $.set_text(text_1, $0), [() => titleText()]);
						$.append($$anchor, div);
					};

					var d = $.derived(() => titleText());

					$.if(node, ($$render) => {
						if ($.get(d)) $$render(consequent_1);
					});
				}

				var div_1 = $.sibling(node, 2);
				var text_2 = $.child(div_1, true);

				$.reset(div_1);
				$.action(div_1, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
				$.template_effect(($0) => $.set_text(text_2, $0), [() => descriptionText()]);
				$.append($$anchor, fragment_1);
			},
			$$slots: { icon: true, default: true }
		});
	}

	$.pop();
}